<template>
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h2 class="modal-title">Добавить модель</h2>
        <button type="button" class="close" @click="hide()" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body pb-0">
        <div class="form-group">
          <label for="model-name">Название</label>
          <input
            type="text"
            class="form-control"
            id="model-name"
            data-vv-as="Название"
            name="name"
            v-validate="'required'"
            v-model="name"
          >
          <div v-if="errors.first('name')" class="invalid-feedback">
            {{ errors.first('name') }}
          </div>
        </div>

        <div class="form-group mb-3">
          <label>Тип</label>
          <server-select
            v-model="type"
            label="name"
            endpoint="machines/types"
            data-vv-as="Тип"
            name="type"
            v-validate="'required'"
          />
          <div v-if="errors.first('type')" class="invalid-feedback">
            {{ errors.first('type') }}
          </div>
        </div>

        <div class="form-group mb-3" v-if="$root.isAdmin()">
          <label>Организация</label>
          <server-select
            v-model="region"
            label="short_name"
            endpoint="regions/options"
          />
        </div>
      </div>
      <div class="modal-footer">
        <btn-action class="btn btn-primary ml-auto" @click="save">Сохранить</btn-action>
      </div>
    </div>
  </div>
</template>

<script>
  import api from '@/api'

  export default {
    data () {
      return {
        region: null,
        name: '',
        description: '',
        type: null,
      }
    },
    methods: {
      save () {
        this.$validator.validateAll().then(success => {
          if (success) {
            return api.post('models', {
              name: this.name,
              description: this.description,
              type_id: this.type.id,
              region_id: this.region ? this.region.id : null,
            }).then(({data}) => {
              this.$router.push('/admin/models/' + data.id)
            })
          }
        })
      },
      hide () {
        this.$emit('hide')
      },
    },
  }
</script>

<style lang="scss"></style>



// WEBPACK FOOTER //
// resources/assets/js/components/model-modal.vue